export function setupLivechat(item) {
  if (window.__lc?.license === item.id) return null

  window.__lc = window.__lc || {}
  window.__lc.license = item.id
  window.__lc.group = item.group
  ;(function (n, t, c) {
    function i(n) {
      return e._h ? e._h.apply(null, n) : e._q.push(n)
    }
    var e = {
      _q: [],
      _h: null,
      _v: '2.0',
      on() {
        i(['on', c.call(arguments)])
      },
      once() {
        i(['once', c.call(arguments)])
      },
      off() {
        i(['off', c.call(arguments)])
      },
      get() {
        if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.")
        return i(['get', c.call(arguments)])
      },
      call() {
        i(['call', c.call(arguments)])
      },
      init() {
        const n = t.createElement('script')
        ;((n.async = !0), (n.type = 'text/javascript'), (n.src = 'https://cdn.livechatinc.com/tracking.js'), t.head.appendChild(n))
      },
    }
    ;(!n.__lc.asyncInit && e.init(), (n.LiveChatWidget = n.LiveChatWidget || e))
  })(window, document, [].slice)

  let loaded = false
  let callback = null

  function liveCall(action, param) {
    if (loaded) {
      livechatClient.call(action, param)
    } else {
      callback = function () {
        livechatClient.call(action, param)
      }
    }
  }

  const livechatClient = window.LiveChatWidget || undefined
  livechatClient.on('ready', () => {
    loaded = true
    if (callback) {
      callback()
      callback = null
    }
  })

  return {
    maximize() {
      try {
        liveCall('maximize')
      } catch (error) {
        console.log('Livechat not ready yet')
      }
    },
    minimize() {
      try {
        liveCall('minimize')
      } catch (error) {
        console.log('Livechat not ready yet')
      }
    },
    hide() {
      try {
        liveCall('hide')
      } catch (error) {
        console.log('Livechat not ready yet')
      }
    },
    setUser(uidSite) {
      liveCall('set_customer_name', uidSite)
    },
  }
}
